import { fetcher } from '@commenda/utils';
import { TEMPLATE_CATEGORIES_URL } from './helpers';

// Refuses with a 409 naming the count while non-archived templates still point at the category,
// and refuses again if it is already archived — unlike a template, whose archive is idempotent.
export const archiveDocumentAssemblerTemplateCategory = async (
  categoryId: string
): Promise<Response> => {
  const res = await fetcher(
    `${TEMPLATE_CATEGORIES_URL}/${categoryId}/archive`,
    { method: 'POST', body: {} }
  );
  return res;
};
